import { v4 as uuidv4 } from "uuid";
export class PAReviewScheduleMeetingModel {
    constructor() {
        this.id = uuidv4();
        this.reviewId = uuidv4();
        this.reviewMeetingName = "";
        this.reviewMeetingDateAsString = null;
        this.reviewMeetingURL = "";
        this.reviewMeetingLocation = "";
        this.reviewMeetingNotes = "";
        this.reviewMeetingStartTime = "";
        this.reviewMeetingEndTime = "";
        this.reviewParticipants = [];
    }
}
export default class PAReviewScheduleMeeting extends PAReviewScheduleMeetingModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
